// src/services/caseDashboardService.js
import axiosInstance from "../config/axiosInstance";

const BASE_URL = "/CaseDashboard";

/**
 * Obtiene el dashboard de carga de trabajo del abogado autenticado.
 * Endpoint sugerido:
 *   [GET] /api/case-dashboard/my/workload?from=YYYY-MM-DD&to=YYYY-MM-DD
 *
 * @param {string|null} from - Fecha inicio (YYYY-MM-DD) (opcional)
 * @param {string|null} to - Fecha fin (YYYY-MM-DD) (opcional)
 * @returns {Promise<ApiResponse<LawyerWorkloadDashboardDto>>}
 */
export const getMyLawyerWorkloadDashboard = async (from = null, to = null) => {
  const params = new URLSearchParams();
  if (from) params.append("from", from);
  if (to) params.append("to", to);

  const qs = params.toString();
  const { data } = await axiosInstance.get(
    `${BASE_URL}/my/workload${qs ? `?${qs}` : ""}`
  );
  return data;
};

/**
 * Obtiene el dashboard de carga de trabajo de un abogado específico (admin/supervisor).
 * Endpoint sugerido:
 *   [GET] /api/case-dashboard/lawyers/{lawyerId}/workload?from=YYYY-MM-DD&to=YYYY-MM-DD
 *
 * @param {string} lawyerId - Guid del abogado
 * @param {string|null} from - Fecha inicio (YYYY-MM-DD) (opcional)
 * @param {string|null} to - Fecha fin (YYYY-MM-DD) (opcional)
 * @returns {Promise<ApiResponse<LawyerWorkloadDashboardDto>>}
 */
export const getLawyerWorkloadDashboard = async (
  lawyerId,
  from = null,
  to = null
) => {
  if (!lawyerId) throw new Error("lawyerId is required");

  const params = new URLSearchParams();
  if (from) params.append("from", from);
  if (to) params.append("to", to);

  const qs = params.toString();
  const { data } = await axiosInstance.get(
    `${BASE_URL}/lawyers/${lawyerId}/workload${qs ? `?${qs}` : ""}`
  );
  return data;
};
